"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetButtonPermission = void 0;
const react_1 = require("react");
const styled_1 = require("@framework/styled");
const useSetButtonPermission = (permissionRole, id) => {
    const context = (0, styled_1.useListItemContext)();
    const hasPermission = (0, react_1.useMemo)(() => {
        if (!id || !context) {
            return false;
        }
        if (!context.callbackResponse[id]) {
            return false;
        }
        return context.callbackResponse[id].some(item => item.role === permissionRole);
    }, [context, permissionRole]);
    return {
        hasPermission,
    };
};
exports.useSetButtonPermission = useSetButtonPermission;
//# sourceMappingURL=use-set-button-permission.js.map